import Icon from '@ramsey-design-system/icon';
import { ChevronLeftIcon } from '@ramsey-design-system/icons';
import { useWizard } from 'react-use-wizard';

function MatcherBackChevron({
  dataTestID,
  onBack
}: Readonly<{ dataTestID: string; onBack?: () => void }>) {
  const { previousStep, isFirstStep } = useWizard();
  return (
    <button
      data-testid={dataTestID}
      className={
        'min-w-6 min-h-6 m-[-17px] flex justify-center items-center bg-transparent border-none p-0' +
        (isFirstStep ? ' invisible' : ' cursor-pointer')
      }
      onClick={isFirstStep ? undefined : (onBack ?? (() => previousStep()))}
    >
      <Icon
        size="small"
        icon={ChevronLeftIcon}
        className={'text-blue-50' + (isFirstStep ? ' invisible' : '')}
      />
    </button>
  );
}

export { MatcherBackChevron };
